"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Dropdown_1 = __importDefault(require("components/design-system/dropdown/Dropdown"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const TruncateParagraph_1 = __importDefault(require("components/shared/TruncateParagraph"));
const HelperUtils_1 = require("utils/HelperUtils");
const useFilter_1 = __importDefault(require("src/hooks/global-state/useFilter"));
const AdvanceFilter_1 = require("src/components/filter/AdvanceFilter");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const defaultOptions = [
    {
        direction: 'asc',
        id: 0,
        name: `${(0, HelperUtils_1.getObjectiveLocale)('Due Date')}`,
        type: 'due_date'
    },
    {
        direction: 'desc',
        id: 1,
        name: `${(0, HelperUtils_1.getObjectiveLocale)('Newest')}`,
        type: 'created_at'
    },
    {
        direction: 'asc',
        id: 2,
        name: `${(0, HelperUtils_1.getObjectiveLocale)('Oldest')}`,
        type: 'created_at'
    },
    {
        direction: 'asc',
        id: 3,
        name: `${(0, HelperUtils_1.getObjectiveLocale)('A to Z')}`,
        type: 'name'
    },
    {
        direction: 'desc',
        id: 4,
        name: `${(0, HelperUtils_1.getObjectiveLocale)('Z to A')}`,
        type: 'name'
    }
];
const FilterSort = ({ sortOptions, customClass }) => {
    const { id } = (0, AdvanceFilter_1.useAdvanceFilter)();
    const filter = (0, useFilter_1.default)(state => state.filter, (oldState, newState) => {
        return (oldState[id]?.sortDirection === newState[id]?.sortDirection &&
            oldState[id]?.sortColumn === newState[id]?.sortColumn);
    });
    const options = sortOptions || defaultOptions;
    const selectedValue = options.find(option => option.direction === filter[id]?.sortDirection &&
        option.type === filter[id]?.sortColumn)?.name || options[0].name;
    return (react_1.default.createElement(Dropdown_1.default, { customClass: customClass },
        react_1.default.createElement(Dropdown_1.default.Trigger, null,
            react_1.default.createElement("div", { className: "flex justify-between items-center bg-n-000 h-[32px] py-[8px] pr-[4px] pl-[16px] min-w-[180px] max-w-[224px] border border-solid border-n-400 rounded-[4px]" },
                react_1.default.createElement("div", { className: "w-[124px]" },
                    react_1.default.createElement(TruncateParagraph_1.default, { className: "mr-[4px] typography-h400" },
                        (0, HelperUtils_1.getObjectiveLocale)('Sort'),
                        " by: ",
                        selectedValue)),
                react_1.default.createElement(SVGIcon_1.default, { size: 24, fillColor: "var(--n-600)", iconName: "icon-unfold_more" }))),
        react_1.default.createElement(Dropdown_1.default.MenuItems, { type: "fixed" }, options.map((option, index) => (react_1.default.createElement(SortItem, { key: index, option: option }))))));
};
const SortItem = ({ option }) => {
    const { id } = (0, AdvanceFilter_1.useAdvanceFilter)();
    const filter = (0, useFilter_1.default)(state => state.filter);
    const setFilter = (0, useFilter_1.default)(state => state.setFilter);
    const handleSelect = (sortDirection, sortColumn) => {
        const newFilter = (0, cloneDeep_1.default)(filter[id]);
        newFilter.sortDirection = sortDirection;
        newFilter.sortColumn = sortColumn;
        setFilter(id, newFilter);
    };
    return (react_1.default.createElement(Dropdown_1.default.MenuItem, { customClass: "!min-w-[180px] !max-w-[224px]", onClick: () => handleSelect(option.direction, option.type), dataCy: "option-sort" }, option.name));
};
exports.default = FilterSort;
